import { connect, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { useState, useEffect, useCallback } from "react";
import { getApps, getApp, deleteApp } from "../../../../../action/masters/appActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import { alertConstants, getAlertData } from "../../../../../helper/sweet-alert";
import { IAppIndex, IAppData } from "../../../../../models/master/apps";
import { setApps } from "../../../../../store/slices/master/appSlice";
import AppCreate from "./appCreate";
import AppEdit from "./appEdit";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../../common-components/floatingdropdown";
import { getUserTypes } from "../../../../../action/common/commonActionCreator";
import { sortAlphabetically } from "../../../../../common-functions/commonFunctions";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";

const AppsIndex = (props: IAppIndex) => {
  const { getApps, apps, getApp, app, deleteApp, userTypes, getUserTypes } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [selectedUserType, setSelectedUserType] = useState<number | null>(null);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getApp(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteApp(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllApps(selectedUserType ?? undefined);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllApps = async (userType?:number) => {
    setIsLoading(true);
    try {
      await getApps(userType);
    } finally {
      setIsLoading(false);
    }
  };

  const onUserTypeChange = useCallback( (e: any ) => {
    if(e.target.name == "userType")
    setSelectedUserType(e.target.value)
    getAllApps(e.target.value)
  },[])
  

  useEffect(() => {
    getAllApps();
    getUserTypes();
    return () => {
      dispatch(setApps([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Apps</h2>
          <div className="side-filter">
          <div className="justify-content-left">
            <FloatingLabelDropDown
            label=""
            placeholder="-Select UserType-"
            onChange={(e : any) => onUserTypeChange(e)}
            isMandatory={false}
            value={selectedUserType}
            name="userType"
            optionsList={sortAlphabetically(
              userTypes?.filter((type) => type.id !== UserTypes.Freshman)
            )}
          />
          </div>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={() => {
              handleCreateOpen();
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : apps && apps.length > 0 ? (
            apps.map((app: IAppData) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !app.isActive ? "none" : "auto",
                    opacity: !app.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(app.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(app.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={app.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img src={app.image ? baseURL + app.image : ""} />
                      </div>
                      <h2>{app.name}</h2>
                      <p className="para-hide-1">{app.description}</p>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <AppCreate
          setShowCreate={handleCreateClose}
          getAllApps={() => getAllApps(selectedUserType ?? undefined)}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <AppEdit
            setShowEdit={handleEditClose}
            getAllApps={() => getAllApps(selectedUserType ?? undefined)}
            app={app}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getApps: (userType?:number) => getApps(userType),
  getApp: (id: number) => getApp(id),
  deleteApp: (id: number, callBack: Function) => deleteApp(id, callBack),
  getUserTypes: () => getUserTypes(),
};

function mapStateToProps(state: any) {
  return {
    apps: state.app.apps,
    app: state.app.app,
    userTypes: state.common.userTypes,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppsIndex);